import { getRuleElementPropsFromPresentation } from '@wix/rules-panel-ui';
export const getRuleElementPropsFromCapabilities = capabilities => getRuleElementPropsFromPresentation(capabilities.wizardPresentation);
export const getFixerDesignPropsFromCapabilities = capabilities => {
  if (capabilities.compactPanelChrome) {
    return {
      formGap: 'SP3',
      radioGroup: {
        optionElementMarginTop: 'SP2'
      },
      ruleFooter: {
        buttonSize: 'small',
        marginTop: 'SP2'
      }
    };
  }
  return {
    formGap: 'SP1',
    radioGroup: {
      optionElementMarginTop: 'SP1'
    },
    ruleFooter: {
      buttonSize: 'tiny',
      marginTop: '0px'
    },
    ruleLayout: {
      gap: 'SP2'
    }
  };
};
export const getFooterButtonTypesFromCapabilities = capabilities => ({
  dismiss: capabilities.compactPanelChrome ? 'button' : 'textButton'
});
//# sourceMappingURL=get-fixer-design-props.js.map